import {InputSProps} from "@FRAMEWORK/ui/types/d";
import React, {forwardRef} from "react";
import styled, {css} from "styled-components";

interface Component extends InputSProps {
	id?: string;
	value?: string;
	checked: boolean;
	bg?: string;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Input = styled.input<Component>`
	position: relative;
	width: 20px;
	height: 20px;
	padding: 0;
	border: none;
	background-color: #fff;
	cursor: pointer;
	border: 1px solid var(--line-color);

	&:checked {
		border-color: var(--emp-color);
		background-color: var(--emp-color);
		&:after {
			position: absolute;
			left: 50%;
			top: 5px;
			width: 5px;
			height: 9px;
			border: solid #fff;
			border-width: 0 2px 2px 0;
			transform: rotate(45deg) translateX(-65%);
			content: "";
		}
	}

	&:disabled {
		background-color: var(--disabled-color);
		border-color: var(--line-color);
		cursor: initial;

		&:after {
			border-color: var(--gray-color);
			cursor: initial;
		}
		+ label {
			cursor: initial;
		}
	}

	${props => {
		if (props.bg === "yellow") {
			return css`
				background-color: #f6f7f2;

				&:checked {
					background-color: var(--emp-color);

					&:after {
						position: absolute;
						left: 5px;
						top: 1px;
						width: 5px;
						height: 9px;
						border: solid #fff;
						border-width: 0 3px 3px 0;
						transform: rotate(45deg);
						content: "";
					}
				}
			`;
		}
	}}
`;

const Checkbox = forwardRef<HTMLInputElement, Component>(({id, ...props}: Component, ref) => (
	<Input type="checkbox" id={id} {...props} ref={ref} />
));

export default Checkbox;
